import { Segment, SegmentContent } from '@/platform/ui';

// Fills the page behind a side panel so the backdrop has something to cover.
const PagePlaceholder = () => (
    <Segment>
        <SegmentContent>
            <div
                aria-hidden='true'
                className='flex animate-pulse flex-col gap-4'
            >
                <div className='h-6 w-1/3 rounded bg-gray-200' />
                {Array.from({ length: 8 }, (_, index) => (
                    <div key={index} className='h-4 rounded bg-gray-100' />
                ))}
            </div>
        </SegmentContent>
    </Segment>
);

export default PagePlaceholder;
